import styled from "styled-components";
export const ContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
export const BoxStyled = styled.div`
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
  margin: 0 24px 12px;
  padding: 24px 24px;
  border-radius: 18px;
  background-color: #f6f7f9;
  width: 100%;
  height: 85vh;
  overflow-y: scroll;
  overflow-x: hidden;
`;
export const HeaderStyled = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 10px;
`;
export const HeaderText = styled.div`
  font-size: 20px;
  font-weight: 900;
  white-space: nowrap;
`;
export const AddTicket = styled.div`
  white-space: nowrap;
  margin: 0 10px;
  padding: 13px 20px 12px 18px;
  border-radius: 14px;
  box-shadow: 0 1px 3px 0 rgba(53, 58, 80, 0.1);
  background-color: #fff;
  cursor: pointer;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;
export const CallBtn = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 14px;
  border-radius: 14px;
  box-shadow: 0 1px 3px 0 rgba(53, 58, 80, 0.1);
  background-color: #fff;
  cursor: pointer;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;
export const CallAndTicketContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
